import {
  VehicleDataType,
  VehicleFieldsType,
} from 'QuoteApp/services/endpoints/GetDetails';
import { GetConfigResponseType } from '../../../services/endpoints/GetConfig';

export type UsageDetailsType =
  GetConfigResponseType['vehicles']['usageDetails'];

export type VehicleFormFieldKeys = keyof Omit<
  VehicleFieldsType,
  'editable' | 'lienHolder' | 'garagingAddress' | 'parkingDetails'
>;

export const antiTheftOptions: {
  key: Partial<VehicleFormFieldKeys>;
  label: string;
}[] = [
  { key: 'alarm', label: 'Alarm' },
  { key: 'activeDisable', label: 'Active Disable' },
  { key: 'passiveDisable', label: 'Passive Disable' },
  { key: 'recovery', label: 'Recovery' },
];

const usageDetailsOptions: {
  key: Partial<VehicleFormFieldKeys>;
  label: string;
}[] = [
  {
    key: 'usedInMexico',
    label:
      'This vehicle is used to commute to and from work in Mexico or is regularly garaged at a Mexican address.',
  },
  {
    key: 'availableForNonCoveredDrivers',
    label:
      'This vehicle is regularly available for use by drivers not on this policy, including sharing programs, rentals, or other regular use.',
  },
  {
    key: 'feeBasedServices',
    label: 'This vehicle is used commercially, such as for delivery.',
  },
  {
    key: 'hazmatToolTransport',
    label:
      'This vehicle is used to transport hazardous materials or tools/equipment to or from a work or jobsite.',
  },
  {
    key: 'usedAsResidence',
    label:
      'This vehicle is lived in as a primary residence by you or another individual on the policy.',
  },
  {
    key: 'emergencyServices',
    label: 'This vehicle is used for emergency services or response.',
  },
];

export const getFilteredUsageDetailsOptions = (
  usageDetails: UsageDetailsType | undefined
) => {
  return usageDetailsOptions.filter((option) =>
    option.key === 'usedInMexico' ? usageDetails?.usedInMexico?.required : true
  );
};

export const isUncheckedUsageDetailsOptions = (
  usageDetails: UsageDetailsType,
  vehiclesDetails: VehicleDataType
) => {
  const filteredUsageDetailsOptions =
    getFilteredUsageDetailsOptions(usageDetails);
  return Object.keys(vehiclesDetails)
    .filter((key) =>
      filteredUsageDetailsOptions.find((option) => option.key === key)
    )
    .every((key) => {
      const vehicleDetail = vehiclesDetails[key as keyof VehicleDataType];
      return typeof vehicleDetail === 'object' &&
        vehicleDetail !== null &&
        'value' in vehicleDetail
        ? vehicleDetail.value === 'false'
        : false;
    });
};

export const isUncheckedOptionsValues = (
  usageDetails: UsageDetailsType,
  values: VehicleFieldsType
) => {
  const filteredUsageDetailsOptions =
    getFilteredUsageDetailsOptions(usageDetails);
  return Object.keys(values)
    .filter((key) =>
      filteredUsageDetailsOptions.find((option) => option.key === key)
    )
    .every((key) => {
      return typeof values === 'object' &&
        values !== null &&
        values?.hasOwnProperty(key)
        ? values[key as keyof VehicleFieldsType] === 'false' ||
            !values[key as keyof VehicleFieldsType]
        : false;
    });
};
